import styled, { css } from 'styled-components';
import { siteContainer, container } from '~layout';
var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-11pp7qm-0"
})(["align-items:center;display:flex;flex-direction:", ";height:100%;justify-content:", ";margin:0 auto;", " ", ""], function (_ref) {
  var isVertical = _ref.isVertical;
  return isVertical ? 'column' : 'row';
}, function (_ref2) {
  var isVertical = _ref2.isVertical;
  return isVertical ? 'center' : 'flex-start';
}, function (_ref3) {
  var isVertical = _ref3.isVertical,
      isFullWidth = _ref3.isFullWidth;
  return !isVertical && !isFullWidth && css(["", ""], siteContainer);
}, function (_ref4) {
  var isVertical = _ref4.isVertical,
      isFullWidth = _ref4.isFullWidth;
  return !isVertical && isFullWidth && css(["", ""], container);
});
export default Inner;